import React, { useState, useEffect } from "react";
import {
  X,
  ChevronLeft,
  ChevronRight,
  Play,
  Pause,
  ChevronDown,
} from "lucide-react";

const Services = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [isSlideshow, setIsSlideshow] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);

  const images = [
    { src: "3.jpg", title: "At the Hotel", location: "TANZANIA" },
    { src: "4.jpg", title: "At the Hotel with CEO AFRICAN ADVENTURE TRAVELLERS", location: "TANZANIA" },
    { src: "9.jpg", title: "Safari Vehicle", location: "Tarangire" },
    { src: "10.jpg", title: "Valley View", location: "Serengeti" },
    { src: "13.jpg", title: "Landscape with Wildbeest", location: "Tarangire" },
    { src: "14.jpg", title: "CEO,African Adeventure Travellers", location: "Tarangire" },
    { src: "15.jpg", title: "Tarangire National Park", location: "Tanzania" },
    { src: "19.jpg", title: "Baobao Trees", location: "Tarangire" },
    { src: "20.jpg", title: "Tanzania natives", location: "Tanzania" },
    { src: "21.jpg", title: "Ngorongoro Conservation Area", location: "Ngorongoro" },
    { src: "22.jpg", title: "CEO with our tourists getting lunch in Tz", location: "Ngorongoro" },
    { src: "24.jpg", title: "CEO with Tanzania natives", location: "Slopes of Mt.Kilimanjaro" },
    { src: "25.jpg", title: "Maasai People homestaed", location: "Slopes of Mt.Kilimanjaro" },
    { src: "28.jpg", title: "Lions Spotted resting", location: "Serengeti" },
    { src: "29.jpg", title: "Tourists & CEO on Safari Vehicles", location: "Serengeti" },
    { src: "30.jpg", title: "Wildebeest", location: "Serengeti" },
    { src: "31.jpg", title: "Safari Tour", location: "Kilimanjaro Area" },
    { src: "32.jpg", title: "Tarangire National Park", location: "Tarangire" },
    { src: "33.jpg", title: "Landscape", location: "Tarangire" },
    { src: "34.jpg", title: "Lions Spotted resting", location: "Serengeti" },
    { src: "36.jpg", title: "Tourists interact with the natives", location: "Tanzania" },
    { src: "37.jpg", title: "Zebra grazing", location: "Serengeti" },
    { src: "38.jpg", title: "CEO selfie on the safari vehicles", location: "Serengeti" },
    { src: "39.jpg", title: "Grassland View", location: "Kilimanjaro" },
    { src: "40.jpg", title: "Maasai People", location: "Tanzania" },
    { src: "41.jpg", title: "Lions resting in the savannah", location: "Serengeti" },
    { src: "42.jpg", title: "Baobao Tree", location: "Tarangire" },
    { src: "43.jpg", title: "Tanzania natives", location: "Slopes of Mt.Kilimanjaro" },
    { src: "44.jpg", title: "Ngorongoro Conservation Area", location: "Ngorongoro" },
    { src: "45.jpg", title: "Zebras grazing", location: "Serengeti" },
    { src: "46.jpg", title: "Ngorongoro grassland", location: "Ngorongoro" },
    { src: "47.jpg", title: "Lunch at Serengeti Park", location: "Serengeti" },
    { src: "48.jpg", title: "Zebras in the Serengeti grassland", location: "Serengeti" },
    { src: "49.jpg", title: "Conservation", location: "Serengeti" },
    { src: "50.jpg", title: "Ngorongoro Conservation Area", location: "Ngorongoro" },
    { src: "51.jpg", title: "Safari", location: "Tarangire" },
    { src: "52.jpg", title: "Young Zebras", location: "Serengeti" },
    { src: "53.jpg", title: "Lion in Serengeti grassland", location: "Serengeti" },
    { src: "54.jpg", title: "Lion After a Hunt", location: "Serengeti" },
    { src: "55.jpg", title: "Antelope in Serengeti grassland", location: "Serengeti" },
    { src: "57.jpg", title: "Lions resting in the savannah", location: "Serengeti" },
    { src: "58.jpg", title: "Zebras resting under the tree shade", location: "Tarangire" },
    { src: "66.jpg", title: "Evening sunset, back to the Hotel", location: "Tarangire" },
    { src: "67.jpg", title: "Young zebra in the savannah", location: "Tarangire" },
  ];

  const faqs = [
    {
      question: "What is the best time to visit Tanzania?",
      answer:
        "The best time is during the dry season from June to October for wildlife viewing, especially the Great Migration in Serengeti.",
    },
    {
      question: "Do I need a visa to travel to Tanzania?",
      answer:
        "Most visitors require a visa. You can obtain it on arrival or apply online in advance. Check with your local Tanzanian embassy.",
    },
    {
      question: "Are safari vehicles safe and comfortable?",
      answer:
        "Yes! Our 4x4 Land Cruisers have pop-up roofs, comfortable seats, charging ports, and experienced driver-guides.",
    },
    {
      question: "What should I pack for a Tanzania safari?",
      answer:
        "Pack neutral-colored clothing, sunscreen, rain jacket, hat, camera, insect repellent, and comfortable walking shoes.",
    },
    {
      question: "Is Tanzania family-friendly?",
      answer:
        "Absolutely! We offer family safaris with kid-friendly lodges, activities, and flexible itineraries.",
    },
  ];

  useEffect(() => {
    let interval;
    if (isSlideshow && selectedImage !== null) {
      interval = setInterval(() => {
        setSelectedImage((prev) => (prev + 1) % images.length);
      }, 3000);
    }
    return () => clearInterval(interval);
  }, [isSlideshow, selectedImage, images.length]);

  const openLightbox = (i) => {
    setSelectedImage(i);
    document.body.style.overflow = "hidden";
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    setIsSlideshow(false);
    document.body.style.overflow = "unset";
  };

  const goToNext = () => setSelectedImage((prev) => (prev + 1) % images.length);
  const goToPrevious = () =>
    setSelectedImage((prev) => (prev - 1 + images.length) % images.length);

  const toggleFaq = (i) => setOpenFaq(openFaq === i ? null : i);

  return (
    <div className="bg-white min-h-screen overflow-hidden">

      {/* FONT UTILITIES */}
      <style jsx>{`
        @layer utilities {
          .font-body { font-family: 'Times New Roman', Times, serif; }
        }
      `}</style>

      {/* QUOTE */}
      <div className="py-12 flex items-center justify-center bg-white px-4">
        <p
          className="text-3xl md:text-4xl font-body font-medium text-center italic"
          style={{ color: "#2f4f2f", lineHeight: '1.7' }}
        >
          "Cherishing Our Moments in Tanzania."
        </p>
      </div>

      {/* GALLERY GRID */}
      <div className="px-4 py-10 max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {images.map((img, i) => (
          <div
            key={i}
            className="relative cursor-pointer overflow-hidden rounded-lg shadow-lg transform transition duration-500 hover:scale-105 hover:shadow-2xl"
            onClick={() => openLightbox(i)}
          >
            <img
              src={`/${img.src}`}
              alt={img.title}
              className="w-full h-64 object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
              <div className="text-white font-body" style={{ lineHeight: '1.7' }}>
                <p className="text-xs uppercase tracking-wider font-normal">
                  {img.location}
                </p>
                <h3 className="font-medium text-sm mt-1">{img.title}</h3>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* FAQ SECTION */}
      <section className="max-w-4xl mx-auto px-6 py-20">
        <h2
          className="text-4xl md:text-5xl text-center mb-16 tracking-wide uppercase font-body"
          style={{
            color: "#2f4f2f",
            letterSpacing: "0.15em",
            fontWeight: 600,
            lineHeight: '1.7'
          }}
        >
          Frequently Asked Questions
        </h2>

        <div className="space-y-6">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="border-b border-gray-200 pb-4 cursor-pointer"
              onClick={() => toggleFaq(i)}
            >
              <div className="flex justify-between items-center">
                <h3
                  className="text-lg md:text-xl font-body font-medium text-gray-800 pr-8"
                  style={{ lineHeight: '1.7' }}
                >
                  {faq.question}
                </h3>
                <ChevronDown
                  className={`w-6 h-6 text-[#2f4f2f] transition-transform duration-300 ${
                    openFaq === i ? "rotate-180" : ""
                  }`}
                />
              </div>

              <div
                className={`overflow-hidden transition-all duration-500 ease-in-out ${
                  openFaq === i ? "max-h-40 mt-3" : "max-h-0"
                }`}
              >
                <p
                  className="text-gray-600 leading-relaxed font-body"
                  style={{ lineHeight: '1.7', fontWeight: 'normal' }}
                >
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* LIGHTBOX */}
      {selectedImage !== null && (
        <div className="fixed inset-0 bg-black z-50 flex items-center justify-center">
          <div className="absolute top-0 left-0 right-0 bg-gradient-to-b from-black/80 to-transparent p-6 flex justify-between items-center z-50">
            <div className="text-white font-body" style={{ lineHeight: '1.7' }}>
              <h2 className="text-2xl font-medium">
                {images[selectedImage].title}
              </h2>
              <p className="text-sm text-gray-300 font-normal">
                {images[selectedImage].location}
              </p>
            </div>
            <div className="flex gap-4 items-center">
              <button
                onClick={() => setIsSlideshow(!isSlideshow)}
                className="text-white hover:text-gray-300 p-2 hover:bg-white/10 rounded-full transition-colors"
              >
                {isSlideshow ? <Pause className="w-6 h-6" /> : <Play className="w-6 h-6" />}
              </button>
              <button
                onClick={closeLightbox}
                className="text-white hover:text-gray-300 transition-colors"
              >
                <X className="w-8 h-8" />
              </button>
            </div>
          </div>

          <button
            onClick={goToPrevious}
            className="absolute left-6 text-white hover:text-gray-300 p-3 hover:bg-white/10 rounded-full transition-colors z-50"
          >
            <ChevronLeft className="w-10 h-10" />
          </button>
          <button
            onClick={goToNext}
            className="absolute right-6 text-white hover:text-gray-300 p-3 hover:bg-white/10 rounded-full transition-colors z-50"
          >
            <ChevronRight className="w-10 h-10" />
          </button>

          <div className="relative max-w-5xl max-h-screen p-4">
            <img
              src={`/${images[selectedImage].src}`}
              alt={images[selectedImage].title}
              className="max-w-full max-h-[85vh] object-contain mx-auto rounded"
              style={{ animation: "fadeIn 0.5s ease-in-out" }}
            />
          </div>

          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
            <div className="flex gap-2 mb-4 overflow-x-auto scrollbar-hide">
              {images.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setSelectedImage(idx)}
                  className={`flex-shrink-0 transition-all ${
                    idx === selectedImage ? "w-12 h-1 bg-white" : "w-8 h-1 bg-white/30"
                  }`}
                />
              ))}
            </div>
            <div className="text-center text-white text-sm font-body" style={{ lineHeight: '1.7' }}>
              {selectedImage + 1} / {images.length}
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
};

export default Services;